// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ReviewRouteImport } from './routes/review'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as MiamiAirportLuxuryCarRentalRouteImport } from './routes/miami-airport-luxury-car-rental'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as FleetRouteImport } from './routes/fleet'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CarsIndexRouteImport } from './routes/cars.index'
import { Route as CarsCarIdRouteImport } from './routes/cars.$carId'
import { Route as BookingSuccessRouteImport } from './routes/booking.success'
import { Route as BookingCarIdRouteImport } from './routes/booking.$carId'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminTestimonialsRouteImport } from './routes/admin.testimonials'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminCarsRouteImport } from './routes/admin.cars'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'

const ReviewRoute = ReviewRouteImport.update({
            id: '/review',path: '/review',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const MiamiAirportLuxuryCarRentalRoute = MiamiAirportLuxuryCarRentalRouteImport.update({
            id: '/miami-airport-luxury-car-rental',path: '/miami-airport-luxury-car-rental',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const FleetRoute = FleetRouteImport.update({
            id: '/fleet',path: '/fleet',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const CarsIndexRoute = CarsIndexRouteImport.update({
            id: '/cars/',path: '/cars/',getParentRoute: () => rootRouteImport
          })
const CarsCarIdRoute = CarsCarIdRouteImport.update({
            id: '/cars/$carId',path: '/cars/$carId',getParentRoute: () => rootRouteImport
          })
const BookingSuccessRoute = BookingSuccessRouteImport.update({
            id: '/booking/success',path: '/booking/success',getParentRoute: () => rootRouteImport
          })
const BookingCarIdRoute = BookingCarIdRouteImport.update({
            id: '/booking/$carId',path: '/booking/$carId',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminTestimonialsRoute = AdminTestimonialsRouteImport.update({
            id: '/testimonials',path: '/testimonials',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminCarsRoute = AdminCarsRouteImport.update({
            id: '/cars',path: '/cars',getParentRoute: () => AdminRoute
          })
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })





const AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,AdminCarsRoute: AdminCarsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminTestimonialsRoute: AdminTestimonialsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AuthRoute: AuthRoute,ContactRoute: ContactRoute,FaqRoute: FaqRoute,FleetRoute: FleetRoute,HowItWorksRoute: HowItWorksRoute,MiamiAirportLuxuryCarRentalRoute: MiamiAirportLuxuryCarRentalRoute,PrivacyRoute: PrivacyRoute,ReviewRoute: ReviewRoute,BookingCarIdRoute: BookingCarIdRoute,BookingSuccessRoute: BookingSuccessRoute,CarsCarIdRoute: CarsCarIdRoute,CarsIndexRoute: CarsIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)